var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "       \u003Ca class=\"tenant-link\" ng-href=\"{{vm.href}}\" aria-label=\"{{vm.ariaLabel}}\"\u003E{{vm.label}}\u003C\u002Fa\u003E";;return pug_html;};
module.exports = template;